import * as React from "react";
import { observer, inject } from "mobx-react";
import { useNavigate } from "react-router-dom";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import AlertComponent from "./AlertComponent";
import { FiList, FiLogOut } from "react-icons/fi";
import { LinearProgress } from "@mui/material";

const TopBarMenu = ({ store }) => {
  const navigate = useNavigate();
  const onChangeProject = () => {
    store.setChangeProject();
    navigate("/project");
  };
  const onLogout = () => {
    store.setUserLogout();
    navigate("/panel/kullanici-girisi");
  };

  return (
    <>
      <AppBar sx={{ width: "100%" }}>
        <Toolbar key="topMenu">
          <Typography color="secondary" style={{ fontWeight: "bold" }}>
            {!store.project
              ? "Görüşme Paneli"
              : "Görüşme Paneli" + " - " + store.project.name}
          </Typography>
          <MenuItem
            onClick={() => onChangeProject()}
            style={{
              padding: "13px",
              marginLeft: "auto",
            }}
          >
            <FiList
              style={{
                color: "#f5b532",
                fontSize: "20px",
                marginRight: "5px",
              }}
            />
            <Typography
              variant="body1"
              style={{ fontWeight: "600", color: "#f5b532" }}
            >
              Proje Seç
            </Typography>
          </MenuItem>
          <MenuItem
            onClick={() => onLogout()}
            style={{
              padding: "13px",
            }}
          >
            <FiLogOut
              style={{
                color: "#D14343",
                fontSize: "20px",
                marginRight: "5px",
              }}
            />
            <Typography
              variant="body1"
              style={{ fontWeight: "600", color: "#D14343" }}
            >
              Çıkış Yap
            </Typography>
          </MenuItem>
        </Toolbar>
        <div
          style={{
            position: "absolute",
            height: "5px",
            width: "100%",
            zIndex: "5000",
          }}
        >
          <LinearProgress
            style={{
              display: store.loadingBarStatus ? "none" : "block",
            }}
            color="primary"
          />
        </div>
      </AppBar>
      <AlertComponent />
    </>
  );
};
export default inject("store")(observer(TopBarMenu));
